import env from '~/libs/env'
import get from 'lodash/get'

async function pendoInit(lendioId) {
    const envPrefix = env('environment').toLowerCase()
    await window.pendo.initialize({ visitor: { id: lendioId, env: envPrefix } });
}

async function pendoIdentify({ lendioId, borrower, authUser, portalQualified, fsURL, misc = {} }) {
    // Please use Strings, Numbers, or Bools for value types.
    const envPrefix = env('environment').toLowerCase()
    const pendoId = window.pendo.getVisitorId()
    const dataValueObj = {
        visitor: {
            id: lendioId,
            mostRecentFullStorySession: fsURL,
            env: envPrefix,
            ...misc
        },
        account: {}
    }
    if (authUser) {
        const userData = {
            email: authUser.email,
            full_name: `${authUser.first} ${authUser.last}`,
            okta_user_id: authUser.oktaUserId,
        }
        dataValueObj.visitor = { ...dataValueObj.visitor, ...userData}
    }
    if (borrower) {
        const borrowerData = {
            id: borrower.id,
            borrower_name: borrower.name,
            borrower_created: borrower.created ? new Date(Date(borrower.created)).toISOString() : undefined,
            lead_medium: borrower.leadMedium,
            lead_source: borrower.leadSource,
            borrower_stage: borrower.stage,
            borrower_status: borrower.status,
            mineral_group: borrower.mineralGroup,
            portal_qualified: portalQualified,
            is_test: borrower.isTest,
            industry_type: borrower.industryName,
        }
        dataValueObj.account = { ...dataValueObj.account, ...borrowerData}
    }

    // Scrub out null/undefined values
    Object.keys(dataValueObj.visitor).forEach(e => { if (dataValueObj.visitor[e] === undefined || dataValueObj.visitor[e] === null) delete dataValueObj.visitor[e] })
    Object.keys(dataValueObj.account).forEach(e => { if (dataValueObj.account[e] === undefined || dataValueObj.visitor[e] === null) delete dataValueObj.account[e] })

    if (lendioId === pendoId) {
        await window.pendo.identify(dataValueObj);
        return true
    }
    return false
}

export { pendoInit, pendoIdentify }
